
async function createSetupCheckoutSession({
  subscriptionId
}) {
  const response = await fetch("/checkout/create-session/setup?return_url=/products/manage/" + subscriptionId, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({
      subscriptionId
    })
  });

  if (response.ok) {
    return response.json();
  }

  throw new Error((await response.json()).error);
}

async function copyCode(index = -1) {
  const value = index == -1 ?
    $('.code-input').map((_, i) => i.value).get().join('\n') :
    $('#code-' + index).val();
  await navigator.clipboard.writeText(value);
  $('#copy-success .toast-body').text("Access code(s) copied to clipboard!");
  $('#copy-success').toast('show');
}

async function copyHelpLink() {
  await navigator.clipboard.writeText(WEBSITE + '/create/access-code-help');
  $('#copy-success .toast-body').text("The link copied to clipboard!");
  $('#copy-success').toast('show');
}

window.addEventListener('load', () => {
  /**
   * @type {import('@stripe/stripe-js').Stripe}
   */
  const stripe = Stripe(PUBLISHABLE_KEY);

  $('.update-payments').on('click', e => {
    e.preventDefault();
    createSetupCheckoutSession({
      subscriptionId: e.target.dataset.subid
    })
      .then(({
        sessionId
      }) => {
        return stripe.redirectToCheckout({
          sessionId
        });
      })
      .catch(err => {
        console.error(err);
        $('#manage-error-body').text(err instanceof Error ? err.message : "Could not update payment method. Please try again later.");
        $('#manage-error').toast('show');
      });
  });
  $('.copy-code').on('click', e => copyCode(e.currentTarget.dataset.index));
  $('#reset-code-modal').on('show.bs.modal', e => {
    $('#ac').val(e.relatedTarget.dataset.ac);
  });
  $('#delete-code-modal').on('show.bs.modal', e => {
    $('#delete-ac').val(e.relatedTarget.dataset.ac);
  });
  $('#set-count-modal').on('show.bs.modal', e => {
    $('#set-count-ac').val(e.relatedTarget.dataset.ac);
    $('#set-count').attr('min', Math.max(1, e.relatedTarget.dataset.used));
  });
  $('#add-code-modal').on('show.bs.modal', e => {
    $('#remaining').text(e.relatedTarget.dataset.remaining);
  });
  $('#copy-all').on('click', () => copyCode());
  $('a.list-users').on('click', async e => {
    e.preventDefault();
    const result = await fetch('/products/code/users?code=' + e.target.dataset.code, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      }
    });
    const showDetails = e.target.dataset.showDetails;
    if (result.ok) {
      const info = await result.json();
      // Format last addon load as YYYY-MM-DD (server sends ISO string) or "never"
      // when the Google email has no addon_load history. Admin (details) view
      // always shows the value including "never" so operational status is visible.
      // Customer (non-details) view omits the parenthetical entirely when the user
      // has never opened the addon — no need to clutter the list with "never".
      const fmtLast = last => last ? new Date(last).toISOString().slice(0, 10) : 'never';
      // Escape every interpolated field before .html() (CJ1/CJ2): row.email is
      // attacker-controlled (an access-code redeemer sets it via the base64 email
      // on redemption), and this list is viewed by the code owner and an admin.
      // et_email/name/user_role are filtered on their write paths today, but
      // escaping here closes the sink regardless of any write path.
      const esc = s => String(s == null ? '' : s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
      $('#access-code-users .modal-body').html(info.length ?
        `<ol>` + info.map(row => showDetails ?
          `<li><b>Google:</b> ${esc(row.email)}, <b>Hypatia:</b> ${esc(row.et_email)} (${esc(row.name)}, role: ${esc(row.user_role)}), <b>Last access:</b> ${fmtLast(row.last_access)}` :
          `<li>${esc(row.email)}${row.last_access ? ` (last access: ${fmtLast(row.last_access)})` : ''}`).join('') + `</ol>` :
        "No user used this code yet")
      $('#access-code-users').modal('show');
    }
  });
  $('#copy-access-code-help-link').on('click', () => copyHelpLink());
});